/* eslint-disable no-console, no-undef, camelcase */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import { connect } from 'react-redux';
import { OauthSender } from 'react-oauth-flow';
import _ from 'lodash';
import { toast } from 'react-toastify';
import {
  StyledBody, LogoWrapper, ImageContainer, CustomLabel, CustomCheckbox, Slider,/* LinkedStatus,*/ ButtonContainer,
  StyledTitleNew, CloseIcon, StyledModalNew,
  DeviceContainerNew
} from './styles';
import { FITBIT_URI, FITBIT_CLIENT_ID, REDIRECT_URI, STRAVA_URI, STRAVA_CLIENT_ID, WITHINGS_URI, WITHINGS_CLIENT_ID, STRAVA_AUTHORIZATION_URI, ImageUrl } from '../../utils/constants';
import {
  fitbitIntegration, stravaIntegration, withingsIntegration,
  revokeDevice, updateDevices, getRequestToken, connectDevice,
  getListOfConnectedDevices,fetchConnectedDevices
} from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import { CloseIconBranding } from '../../utils/icons';
import { Divider } from '../UserDashboard/styles';
import DeviceConnectedPopup from '../UserDashboard/DeviceConnectedPopup';

const DEVICE_DATA = {
  FITBIT_URI: FITBIT_URI,
  STRAVA_URI: STRAVA_URI,
  FITBIT_CLIENT_ID: FITBIT_CLIENT_ID,
  STRAVA_CLIENT_ID: STRAVA_CLIENT_ID,
  WITHINGS_CLIENT_ID: WITHINGS_CLIENT_ID,
  WITHINGS_URI: WITHINGS_URI
};

class ConnectDeviceModal extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      devicePopup:false
    };
    this.myref = React.createRef();
  }

  closeDeviceModal = () => {
    // setDevicePopup(false);
    this.setState({devicePopup:false})
    
  }
  openDevicePopup = () =>{
    // setDevicePopup(true);
    this.setState({devicePopup:true})
  }


  displayDeviceModal = () => {
    this.props.fetchConnectedDevices();
    this.setState({ devicePopup: true })
    
  };




  componentDidMount() {

    fetchConnectedDevices();
    if (this.props.location.search) {
      const data = qs.parse(this.props.location.search);
      const oauthTokenSecret = localStorage.getItem('TOKEN_SECRET');
      localStorage.removeItem('TOKEN_SECRET');
      if (this.props.location.search.includes('oauth_token') && oauthTokenSecret) {

        const deviceInfo = {
          "device": "garmin",
          "action": "connect",
          "oauth_token": data.oauth_token,
          "oauth_verifier": data.oauth_verifier,
          "oauth_token_secret": oauthTokenSecret
        };
        this.props.connectDevice(deviceInfo);
      } else if (data.state) {
        let name = '';
        if (data.state === 'strava') {
          name = 'strava'
        }
        else {
          name = JSON.parse(data?.state)?.name;
        }
        const device = this.props.devices.filter((device) => device.name === name);
        if (!_.isEmpty(device) && !device[0].is_connected) {
          if (name === 'fitbit' && localStorage.getItem('fitbitStatus') == 'true') {
            this.props.fitbitIntegration(data.code);
            localStorage.setItem('fitbitStatus', 'false');
          } else if (name === 'strava') {
            const deviceInfo = {
              "device": "strava",
              "action": "connect",
              "oauth_token": data.code,
              "platform": 'web'
            };
            if (!_.isUndefined(data) && data && data.scope && data.scope.split(',').length > 1 && data && data.scope && data.scope.split(',')[1].includes('read_all')) {
              this.props.connectDevice(deviceInfo);
            }
            else {
              toast.info('Please select required permissions', { autoClose: 30000 });
              window.location.href = `${STRAVA_AUTHORIZATION_URI}?client_id=${STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}&approval_prompt=force&scope=read,activity:read_all&state=strava`;
            }
          } else if (name === 'withings') {
            this.props.withingsIntegration(data.code);
          }
        }
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.devicesDisconnectedList !== this.props.devicesDisconnectedList) {
      this.props.closeModal();
    }
  }

  onDeviceToggle = (name, isConnected)=>{
    const {  devices} = this.props;
    if (!isConnected) {
      // const anyDeviceConnected = devices.some((d) => d.is_connected && d.name !== name);
      const connectedCount = devices.filter((d) => d.is_connected).length;

      if (connectedCount >=2) {
        toast.error("You can connect only two device at a time.");
        return; // ⛔ STOP — do not connect
      }
    }
  }

  onChange = (name, url, isConnected) => {

    if (name == 'healthapp' || name == 'googlefit') {
      if (name == 'healthapp') {
        toast.info('Please Authorize Apple Health Kit in Woliba iOS App');
      }
      else {
        toast.info('Please Authorize Google Fit in Woliba Android App');
      }
    }
    else {
      if (isConnected) {
        this.props.updateDevices(name, false);
        this.props.revokeDevice(name);
      } else {
        this.props.updateDevices(name, true);
        // this.setState({devicePopup:true})
        switch (name) {
        case 'fitbit': {
          localStorage.setItem('fitbitStatus', 'true');
          window.open(url, "_blank", "noopener,noreferrer");
          // window.location.href = url;
          break;
        }
        case 'strava': {
          // window.location.href = `${STRAVA_AUTHORIZATION_URI}?client_id=${STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}&approval_prompt=force&scope=read,activity:read_all&state=strava`;
          const authUrl = `${STRAVA_AUTHORIZATION_URI}?client_id=${STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}&approval_prompt=force&scope=read,activity:read_all&state=strava`;
          window.open(authUrl, "_blank", "noopener,noreferrer");
          break;
        }
        case 'withings': {
          window.open(url, "_blank", "noopener,noreferrer");
          // window.location.href = url;
          break;
        }
        case 'garmin': {
          this.props.fetchRequestToken('garmin');
          break;
        }
        default: break;
        }
      }
    }
  };

  render() {
    const { showModal, closeModal, devices, t } = this.props;
    return (
      <>
        <StyledModalNew show={showModal} onHide={() => closeModal()} isWidth={"400px"}>
          <Modal.Header >
            <StyledTitleNew>{t("Link A Device")}</StyledTitleNew>
            <CloseIcon className="closeIcon" style={{bottom:"0px"}}>
              <div style={{cursor:"pointer"}} onClick={() => closeModal()} >{CloseIconBranding("#DA6C74",18,18)}</div>
            </CloseIcon>
          </Modal.Header>
          <Divider isOpacity={"40%"} isMargin={"0px 0px 16px 0px"}></Divider>
          <div className="deviceText">You can connect only two device at a time.</div>
          <StyledBody>
            {
              devices && devices.map((device, index) => {
                {/* const Source = device.name.replace(/ /g, '-'); */}
                const BASE_URI = DEVICE_DATA[`${device.name.toUpperCase()}_URI`];
                const BASE_CLIENT_ID = DEVICE_DATA[`${device.name.toUpperCase()}_CLIENT_ID`];
                const isLast = index === devices.length - 1;
                return (
                  <>
                    <DeviceContainerNew key={index}>
                      <div className="firstCard">
                        <ImageContainer>
                          <img  src={ImageUrl +"/" + device.device_log}  />
                        </ImageContainer>
                        <LogoWrapper>
                          <div>{device.display_name}</div>
                          {/* <LinkedStatus isLinked={device.is_connected}>
                          {device.is_connected ? <span><i className="fas fa-wifi" />&nbsp;<span>{t("Linked")}</span></span> : t('Not Linked')}
                        </LinkedStatus> */}
                        </LogoWrapper>
                      </div>
                      <div style={{marginTop:"20px"}}>
                        {
                          device.name === 'fitbit' || device.name === 'strava' || device.name === 'withings' ?
                            <OauthSender
                              authorizeUrl={BASE_URI}
                              clientId={BASE_CLIENT_ID}
                              redirectUri={REDIRECT_URI}
                              state={{ name: device.name }}
                              render={({ url }) =>
                                <CustomLabel className="switch" onClick={()=>{this.onDeviceToggle(device.name, device.is_connected)}}>
                                  <CustomCheckbox
                                    type="checkbox"
                                    checked={device.is_connected}
                                    disabled={
                                      !device.is_connected &&
                                      devices.filter((d) => d.is_connected).length >= 2
                                    }
                                    // disabled={!device.is_connected && devices.some((d) => d.is_connected && d.name !== device.name)}
                                    onChange={() => {this.onDeviceToggle(device.name, device.is_connected);
                                      if (
                                        (!device.is_connected &&
                                          devices.filter((d) => d.is_connected).length < 2) || (device.is_connected)
                                      ) {
                                        this.onChange(device.name, url, device.is_connected);
                                      }
                                    }}
                                  />
                                  <Slider className="slider round" />
                                </CustomLabel>
                              }
                            /> :
                            <CustomLabel className="switch" >
                              <CustomCheckbox
                                type="checkbox"
                                checked={device.is_connected}
                                onChange={() =>{ this.onDeviceToggle(device.name, device.is_connected);
                                  ((!device.is_connected && devices.filter((d) => d.is_connected).length < 2) || device.is_connected) && this.onChange(device.name, '', device.is_connected);}}
                              />
                              <Slider className="slider round" />
                            </CustomLabel>
                        }
                      </div>
                    </DeviceContainerNew>
                    {/* Divider except after the last row */}
                    {!isLast && (
                      <Divider isWidth={"90%"}  isOpacity="40%" isMargin="12px 20px" />
                    )}
                  </>
                )
              })
            }
            <ButtonContainer />
          </StyledBody>
        </StyledModalNew>
        {this.state.devicePopup && <DeviceConnectedPopup devicePopup={this.state.devicePopup}   openPopup={this.openDevicePopup} history={history}  openConnectDevice={this.displayDeviceModal} closeModal={this.closeDeviceModal}   title={"Device Connected Successfully! !"}  connected={true}/>}
      </>
    )
  }
}

ConnectDeviceModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  fitbitIntegration: PropTypes.func.isRequired,
  stravaIntegration: PropTypes.func.isRequired,
  withingsIntegration: PropTypes.func.isRequired,
  devices: PropTypes.array,
  revokeDevice: PropTypes.func.isRequired,
  updateDevices: PropTypes.func.isRequired,
  fetchRequestToken: PropTypes.func.isRequired,
  connectDevice: PropTypes.func.isRequired,
  fetchConnectedDevices: PropTypes.func.isRequired,
  devicesDisconnectedList: PropTypes.array,
  t: PropTypes.func
};




const mapDispatchToProps = (dispatch) => ({
  fetchConnectedDevices: () => dispatch(getListOfConnectedDevices()),
  fitbitIntegration: (token) => dispatch(fitbitIntegration(token)),
  stravaIntegration: (token) => dispatch(stravaIntegration(token)),
  withingsIntegration: (authToken) => dispatch(withingsIntegration(authToken)),
  revokeDevice: (name) => dispatch(revokeDevice(name)),
  updateDevices: (name, value) => dispatch(updateDevices(name, value)),
  fetchRequestToken: (name) => dispatch(getRequestToken(name)),
  connectDevice: (deviceInfo) => dispatch(connectDevice(deviceInfo))
});

export default connect(null, mapDispatchToProps)(withRouter((withTranslation()(ConnectDeviceModal))));